<template>
    <div class="page-layout blank contacts-manage pt-3 mlr-0">
        <div class="pb-10">
            <div class="d-flex align-items-center py-2" v-if="!is_ticket_not_found">
                <div class='slant-tabs' :class="{'activeTab':active_tab == 'details','new-blue':active_tab == 'details'}" @click="selectViewDetail('details')">
                    <span>Ticket Details</span>  
                </div>
                <div class='slant-tabs ml-1' :class="{'activeTab':active_tab == 'email','new-blue':active_tab == 'email'}" @click="selectViewDetail('email')">
                    <span>Email</span> 
                </div>
                <div class='slant-tabs ml-1' :class="{'activeTab':active_tab == 'comment','new-blue':active_tab == 'comment'}" @click="selectViewDetail('comment')">
                   <span>Comment</span>
                </div>
                <div class='slant-tabs ml-1' :class="{'activeTab':active_tab == 'activity','new-blue':active_tab == 'activity'}" @click="selectViewDetail('activity')">
                   <span>Activity</span> 
                </div>
            </div>
            <div class="vendor-list br-t-l-r py-2" id="printId">
                <!-- <div class="pb-2" style="border-bottom:1.5px solid #005dae">
                    <div class="d-flex align-items-center w-50">
                        <span class="text-secondary fw-600 mr-4"><span>Ticket</span> #50205</span>
                        <img src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/info-24px.svg" alt="" style="height:20px;">
                        <span class="text-secondary fw-600 ml-4">CRM Edit Bug Not Working</span>
                    </div>
                </div> -->
                <details-view @previewImage="previewImage" v-if="active_tab == 'details'" :ticket_id="prop_ticket_id" :showDetails="showDetails" :index="index" @UpdateArchiveListOnStatusChange="UpdateArchiveListOnStatusChange" :is_ticket_not_found="is_ticket_not_found" :list_loader="list_loader"></details-view>
                <ticket-email v-if="active_tab == 'email'" :ticket_id="prop_ticket_id" :showDetails="showDetails"></ticket-email>
                <ticket-activity v-if="active_tab == 'activity'" :ticket_id="prop_ticket_id" :showDetails="showDetails"></ticket-activity>
                <ticket-comments v-if="active_tab == 'comment'" :is_archived="is_archived" :ticket_id="prop_ticket_id" :showDetails="showDetails" :subject="subject" :ticket_number="ticket_number"></ticket-comments>
                <preview @hidePreview="hidePreview" v-if="preview_visible" :file_preview="preview_file" :showDetails="showDetails"></preview>
                <file-viewer v-if="show_file_viewer" :fileType="doc_file_url_type" :fileUrl="file_url_for_view" :file_name_for_view='file_name_for_view' :file_type_for_view="file_type_for_view" @hideFileViewer="hideFileViewer"></file-viewer>
            </div>
        </div>
    </div>
</template>
<script>
import ticket from '../mixins/ticket.js';
import { EventBus } from '../eventBus/nav-bar-event';
var mime = require('mime-types')
const DetailsView = () => import("./DetailsView");
const TicketEmail = () => import("./TicketEmail");
const TicketActivity = () => import("../Tickets/TicketActivity");
const TicketComments = () => import("../Tickets/TicketComments.vue");
const Preview = () => import("../Preview");
const FileViewer = () => import("../FileViewer");
export default {
    mixins:[ticket],
    props:['ticket_id','is_parent_ticket','subject','ticket_number','index', "showDetails", "is_ticket_not_found", 'list_loader'],
    components:{
        DetailsView,
        TicketEmail,
        TicketActivity,
        TicketComments,
        Preview,
        FileViewer
    },
    data(){
        return{
            active_tab:'details',
            active_tab_body:"details",
            preview_file: '',
            preview_visible: false,
            is_archived: true,
            prop_ticket_id: '',
            show_file_viewer: false,
            doc_file_url_type: '',
            file_url_for_view: '',
            file_name_for_view: '',
            file_type_for_view: ''
        }
    },
    methods:{
        UpdateArchiveListOnStatusChange(){
            this.$emit('UpdateArchiveListOnStatusChange')
        },
        selectViewDetail(ticket_obj){
            if(!this.list_loader){
                this.active_tab = ticket_obj
                this.active_tab_body = ticket_obj
            }
        },
        hidePreview(){
            this.preview_visible = false
            EventBus.$emit('ZindexChangeEnd')

        },
        previewImage(file) {
            EventBus.$emit('ZindexChangeStart')
            let content_type = mime.lookup(file.name) ? mime.lookup(file.name) : 'application/octet-stream';
            file['content_type'] = content_type;
            this.preview_file = file;
            if(this.preview_file.name.endsWith('.doc') || this.preview_file.name.endsWith('.docx') || this.preview_file.name.endsWith('.pdf') 
                || this.preview_file.name.endsWith('.ppt') || this.preview_file.name.endsWith('.pptx') || this.preview_file.name.endsWith('.txt') 
                || this.preview_file.name.endsWith('.txt') || this.preview_file.name.endsWith('.xls') || this.preview_file.name.endsWith('.xlsx') 
                || this.preview_file.name.endsWith('.xlsx') || this.preview_file.name.endsWith('.bmp') || this.preview_file.name.endsWith('.jpeg') 
                || this.preview_file.name.endsWith('.png') || this.preview_file.name.endsWith('.svg') || this.preview_file.name.endsWith('.avi') 
                || this.preview_file.name.endsWith('.mp3') || this.preview_file.name.endsWith('.mpeg') || this.preview_file.name.endsWith('.mp4')
                || this.preview_file.name.endsWith('.jpg')
            ){
                if (/\.(docx|xlsx|pptx|doc|xls|ppt|pdf|svg|txt)$/i.test(file.name)) {
                    this.viewFile(this.preview_file)
                } else {
                    this.preview_visible = true;
                }
            } else {
                this.$toasted.global.error("File Format Not Supported")
            }
        },
        viewFile(file) {
            EventBus.$emit('ZindexChangeStart')
            this.file_url_for_view = file.url || "";
            this.file_name_for_view = file.name;
            this.show_file_viewer = true;
            this.file_type_for_view = file.content_type
        },
        hideFileViewer() {
            this.show_file_viewer = false;
            EventBus.$emit('ZindexChangeEnd')
        }
    },
    watch: {
        "$route.params": function (params) {
            if(params) {
                this.active_tab = 'details'
                this.active_tab_body = 'details'
            }
        },
        "active_tab": function(params){
            this.active_tab = params
            this.active_tab_body = params
        },
        "showDetails": function(params){
            this.active_tab = 'details'
            this.active_tab_body = 'details'
        }
    },
    mounted(){
    }
}
</script>
